import RepositoryService from 'src/services/repository'

export default {
  sendAction: async ({ gameId, playerId, actionName }) => {
    const resourcePath = `/multiProject/session/${gameId}/player`
    const actionPath = `${resourcePath}/${playerId}/${actionName}`

    const response = await RepositoryService.base.post(actionPath)

    return response?.data ?? response
  },
  patch: async ({ gameId, playerId, ...data }) => {
    const resource = `/multiProject/session/${gameId}/player`
    return RepositoryService.crud.patch(resource, { id: playerId, ...data })
  },
}
